import { TAddress, TThread } from '../../configuration/common.types';

const isAddressNull = (address: TAddress): boolean => {
    if (!address?.line1 || !address?.line2 || !address?.town) {
        return true;
    }
    return false;
};

export function addressFormatter(
    thread: Pick<TThread, 'address'> | undefined
): string {
    if (!thread?.address || isAddressNull(thread.address)) {
        return 'Purplebricks Property';
    }
    return `${thread.address.line1} ${thread.address.line2}, ${thread.address.town}`;
}
